import React, { useEffect, useState } from 'react';
import './index.scss';

const Checkbox = ({ id, label, name, checked, onChange, disabled = false }) => {
  const handleChange = (e) => {
    onChange && onChange(e);
  };
  const [checkVal, setcheckVal] = useState(checked);
  useEffect(() => {
    setcheckVal(checked);
  }, [checked]);

  return (
    <div className='check'>
      <div className='form-check'>
        <input
          id={id}
          name={name}
          className='form-check-input'
          type='checkbox'
          //value={value}
          onClick={handleChange}
          checked={checkVal}
          disabled={disabled}
        />
        <label className='form-check-label' htmlFor={id}>
          {label}
        </label>
      </div>
    </div>
  );
};

export default Checkbox;
